import Vue from "vue";
import router from "../../router";
import { parse } from "query-string";
import { ajax } from "@/utils/request";
import { notification } from "ant-design-vue";
import Api from "@/api/api";

const state = {
  status: undefined,
  Authority: [],
  userInfo: {}
};

const getters = {
  getAuthority: state => {
    return state.Authority;
  }
};

const actions = {
  async login({ commit }, payload) {
    const response = await ajax({
      url: Api.user_login,
      method: "POST",
      data: payload
    });
    // Login successfully
    if (response.status === 0) {
      Vue.ls.set("SS", response.tk, 24 * 60 * 60 * 1000);
      Vue.ls.set("INFO", response.res, 24 * 60 * 60 * 1000);
      if (response.res.user_level === "超级管理员") {
        commit("setAuthority", "admin");
      } else if (response.res.user_level === "供货商") {
        commit("setAuthority", "user");
      } else {
        commit("setAuthority", "guest");
      }
      //commit("changeLoginStatus", response);
      const urlParams = new URL(window.location.href);
      let redirect = parse(location.search).redirect;
      if (redirect) {
        const redirectUrlParams = new URL(redirect);
        if (redirectUrlParams.origin === urlParams.origin) {
          redirect = redirect.substr(urlParams.origin.length);
          if (redirect.match(/^\/.*#/)) {
            redirect = redirect.substr(redirect.indexOf("#") + 1);
          }
        } else {
          redirect = null;
        }
      }
      router.push({ path: redirect || "/" });
    } else {
      notification.error({
        message: response.res,
        description: response.msg
      });
    }
  },
  async logout({ commit }) {
    commit("changeLoginStatus", {
      status: false,
      currentAuthority: "guest"
    });
    const redirect = parse(location.search).redirect;
    // redirect
    if (window.location.pathname !== "/user/login" && !redirect) {
      router.replace({
        path: "/user/login",
        query: {
          redirect: window.location.href
        }
      });
    }
  }
};

const mutations = {
  changeLoginStatus(state, payload) {
    state.auth = ["admin"];
    state.status = payload.status;
  },
  setAuthority(state, payload) {
    state.Authority[0] = payload;
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
